import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

export type LoadingThemes = 'none' | 'overlay';

@Component({
  selector: 'rx-applications-compact-loading',
  templateUrl: './compact-loading.component.html',
  styleUrls: ['./compact-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass],
})
export class CompactLoadingComponent {
  @Input() theme: LoadingThemes = 'none';

  get containerClass() {
    return `spinner__container--${this.theme}`;
  }
}
